<template>
  <v-dialog
    v-model="showDialogActivateOrDesactivateCampaign"
    max-width="450"
    persistent
    overlay-opacity="0.3"
  >
    <v-card>
      <v-toolbar
        class="elevation-0"
        :class="{ 'grey darken-4': $vuetify.theme.dark }"
        height="64"
      >
        <v-toolbar-title class="d-flex align-center">
          {{ $t("activateOrDesactivateCampaign.title") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text
        class="px-4"
        :class="{ 'grey darken-4': $vuetify.theme.dark }"
      >
        {{
          $t(`activateOrDesactivateCampaign.description.${
            showDialogActivateOrDesactivateCampaignStore.isActivate
            ? 'desactivate'
            : 'activate'
          }`)
        }}
        <span
          class="font-weight-bold"
          :class="$vuetify.theme.dark ? 'white--text' : 'black--text'"
        >
          {{ showDialogActivateOrDesactivateCampaignStore.nameCampaign }}?
        </span>

      </v-card-text>

      <v-card-actions
        class="pa-4"
        :class="{ 'grey darken-4': $vuetify.theme.dark }"
      >
        <v-spacer></v-spacer>
        <v-btn
          outlined
          small
          :disabled="loadingBtn"
          @click="closeDialog"
        >
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn
          class="white--text"
          color="#B50000"
          small
          :loading="loadingBtn"
          :disabled="loadingBtn"
          @click="activateOrDesactivateCampaign"
        >
          {{ $t(`affiliatesCampaigns.${
              showDialogActivateOrDesactivateCampaignStore.isActivate
              ? "desactivate"
              : "activate"
          }`) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogActivateOrDeactivateCampaign",

  data: () => ({
    showDialogActivateOrDesactivateCampaign: false,
    loadingBtn: false,
  }),

  mounted() {
    this.closeDialog();
  },

  watch: {
    showDialogActivateOrDesactivateCampaignStore(dialogState) {
      if (dialogState.status === true) {
        this.showDialogActivateOrDesactivateCampaign = true;
      } else if (!this.showDialogActivateOrDesactivateCampaign) {
        this.closeDialog();
      }
    },
  },

  computed: {
    showDialogActivateOrDesactivateCampaignStore() {
      const dialogState =
        this.$store.getters.getDialogActivateOrDesactivateCampaign;

      return dialogState;
    },
  },

  methods: {
    closeDialog() {
      this.showDialogActivateOrDesactivateCampaign = false;

      if (this.showDialogActivateOrDesactivateCampaignStore.status) {
        this.$store.commit("setDialogActivateOrDesactivateCampaign",
          {
            status: false,
            idCampaign: "",
            nameCampaign: "",
            isActivate: false,
          },
        );
      }
    },
    activateOrDesactivateCampaign() {
      this.loadingBtn = true;

      const body = {
        id: this.showDialogActivateOrDesactivateCampaignStore.idCampaign,
        status: this.showDialogActivateOrDesactivateCampaignStore.isActivate
          ? 0
          : 1,
      };

      this.$axios
        .post(
          `${this.$prefix()}/AffiliateCampaign/activateAndInactivateAfiliateCampaign`,
          this.$formdata(body)
        )
        .then((resp) => {
          this.$store.commit("setFeedbackSnack", {
            msg: resp.data.messages,
            color: "success",
          });

          this.$emit("fetchAffiliateCampaigns");
          this.closeDialog();
        })
        .catch((err) => {
          this.$store.commit("setFeedbackSnack", {
            msg:  err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally(() => {
          this.loadingBtn = false;
        });
    },
  },
};
</script>